// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__2jvgx","drawer":"style_drawer__1lEuG","closeIcon":"style_closeIcon__2HuYo","head":"style_head__11x-O","content":"style_content__1_Jl0"};